export class User {
    public _id: string;
    public apiKey: string;
    public password: string;
    public roles: string[];
    public username: string;
    public phoneNumber: string;

    constructor() { }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/user.ts